// CAN THIS RENDERER COMPILE A NODE MATERIAL? Asked of the renderer itself.
//
// A LEAF MODULE ON PURPOSE. This used to live in `avatarMaterial.js`, and every
// consumer that only wanted the question dragged that module's whole import
// graph in with it — which is fine in the app and was fatal under `node --test`,
// where an extensionless import does not resolve (only a bundler resolves
// those). `hairStrands.js` merely asking the question was enough to take its
// unit test down with `Cannot find module '.../toonRamp'`. That particular
// import is gone with the toon material model, but the reason to keep this a
// leaf stands on its own: nothing here imports anything, so asking is free from
// any context and cannot be broken by someone else's import.
//
// IT IS ASKED OF A RENDERER, NEVER OF A MATERIAL. There is no way to ask a
// material what will draw it, and the wrong guess is SILENT in one direction: a
// raw-GLSL material under `WebGPURenderer` does not fail visibly, it throws
// inside `_renderObjectDirect` mid-frame and leaves every later render for every
// scene drawing nothing.
//
// There used to be a module FLAG here too, set once by whoever built the canvas,
// for code holding no renderer to consult. It is gone with the second renderer:
// with one canvas factory it was a constant `true`, so every gate keyed to it
// had a dead side. The verification harnesses that built a second renderer in
// the same process are gone as well, and they were the case a module flag could
// never have answered correctly anyway.

/**
 * `isWebGPURenderer` is the RENDERER, not the backend: it is true on WebGPU and
 * on three's own WebGL2 backend alike, which is the correct line here — both
 * compile node materials, and only R3F's classic `WebGLRenderer` does not.
 *
 * A missing renderer reads as "cannot", never as "probably can": the failure
 * this guards is a black frame, so the safe answer is the strict one.
 */
export function compilesNodeMaterials(renderer) {
  return renderer?.isWebGPURenderer === true
}
